import { Button, cn } from "web-design-system";
import { useFormContext } from "react-hook-form";

interface Props {
  isUpdate: boolean;
  onReset: () => void;
  dirty: boolean;
  className?: string;
}

export default function FormActions(props: Props) {
  const { isUpdate, onReset, dirty } = props;

  const {
    formState: { isSubmitting, disabled },
  } = useFormContext();

  if (disabled) {
    return null;
  }

  return (
    <div
      className={cn(
        "flex justify-end bottom-0 bg-background z-10 sticky w-full mt-auto pt-4 gap-2",
        props.className
      )}
    >
      <Button
        variant="outline"
        onClick={onReset}
        disabled={isSubmitting || !dirty}
        type="button"
      >
        Reset
      </Button>
      <Button type="submit" disabled={isSubmitting}>
        {isUpdate ? "Update" : "Add"} order
      </Button>
    </div>
  );
}
